import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useEffect, useState } from 'react';
import PubSub from 'pubsub-js';

export const OPEN_ACTION_DIALOG = 'openActionDialog';

function ActionDialog({title}) {
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState();
  const [onAction, setAction] = useState();

  const onOpen = () => {
    setOpen(true);
  }

  const onClose = () => {
    setOpen(false);
  }

  const onConfirm = async () => {
    await onAction();
    onClose();
  }

  useEffect(() => {
    const token = PubSub.subscribe(OPEN_ACTION_DIALOG, (msg, data) => {
      const {content, onConfirm: action} = data;
      setContent(content);
      setAction(action);
      onOpen();
    });
    return () => PubSub.unsubscribe(token);
  }, [])

  return <>
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>{content}</DialogContent>
    <DialogActions>
      <Button onClick={onClose}>關閉</Button>
      <Button onClick={onConfirm}>確認</Button>
    </DialogActions>
  </Dialog>
  </>
}

export default ActionDialog;